import * as React from "react";
const SvgFiRrDominoEffect = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-domino-effect_svg__a)">
      <path
        fill="#062147"
        d="m17.281 5.316-4.666 14a1 1 0 1 1-1.896-.633l4.666-14a1 1 0 1 1 1.896.633m-4.252 4.555a1.493 1.493 0 0 0-1.449-1.884L4 8l1.137-1.434a1.566 1.566 0 0 0-2.404-2.004L.204 8.206a1.14 1.14 0 0 0 .938 1.793h4.789l-1.895 5.053a3.01 3.01 0 0 1-2.81 1.947H.998a1 1 0 1 0 0 2h.228a5.03 5.03 0 0 0 4.683-3.244l1.783-4.756h3.793c.704 0 1.368-.447 1.543-1.129zM23 4a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1m-4 0a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-domino-effect_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDominoEffect;
